import { SubstanceBehaviorEnum, SubstanceFrequencyEnum, SubstancesCategory } from "../../Types/Enums/SubstancesEnums";

export const SUBSTANCES_CATEGORY_MAP = [
  { id: SubstancesCategory.TOBACCO, labels: { 0: "Tabaco", 1: "Tobacco" } },
  { id: SubstancesCategory.VAPE, labels: { 0: "Vapeo", 1: "Vape" } },
  { id: SubstancesCategory.CANNABIS, labels: { 0: "Cannabis", 1: "Cannabis" } },
  { id: SubstancesCategory.ALCOHOL, labels: { 0: "Alcohol", 1: "Alcohol" } },
  { id: SubstancesCategory.STIMULANTS, labels: { 0: "Estimulantes", 1: "Stimulants" } },
  { id: SubstancesCategory.OPIOIDS, labels: { 0: "Opioides", 1: "Opioids" } },
  { id: SubstancesCategory.SEDATIVES, labels: { 0: "Sedantes", 1: "Sedatives" } },
  { id: SubstancesCategory.HALLUCINOGENS, labels: { 0: "Alucinógenos", 1: "Hallucinogens" } },
  { id: SubstancesCategory.INHALANTS, labels: { 0: "Inhalantes", 1: "Inhalants" } },
  { id: SubstancesCategory.OTHER, labels: { 0: "otros", 1: "other" } },
]


export const SUBSTANCES_BEHAVIOR_MAP = [
  { id: SubstanceBehaviorEnum.DEPENDENT, labels: { 0: "dependendencia", 1: "dependant" } },
  { id: SubstanceBehaviorEnum.ANXIETY_STRESS, labels: { 0: "ansiedad/estrés", 1: "anxiety/anxiety" } },
  { id: SubstanceBehaviorEnum.SOCIAL, labels: { 0: "recreativo/social", 1: "recreational/social" } },
  { id: SubstanceBehaviorEnum.ORAL_FIXATION, labels: { 0: "Fijación oral", 1: "oral fixation" } },
  { id: SubstanceBehaviorEnum.STIMULATION, labels: { 0: "estímulo", 1: "stimulation" } },
  { id: SubstanceBehaviorEnum.HABIT, labels: { 0: "hábito", 1: "habit" } },
  { id: SubstanceBehaviorEnum.RECREATIONAL, labels: { 0: "recreativo", 1: "recreational" } },
  { id: SubstanceBehaviorEnum.COPING, labels: { 0: "forma de lidiar con...", 1: "coping" } },
  { id: SubstanceBehaviorEnum.CONFORMITY, labels: { 0: "presión social", 1: "social pressure" } },
  { id: SubstanceBehaviorEnum.ENHANCEMENT, labels: { 0: "Mejorar rendimiento (Físico/Mental)", 1: "Performance Enhancement" } },
  { id: SubstanceBehaviorEnum.CURIOSITY, labels: { 0: "Experimentación / Curiosidad", 1: "Expansion / Curiosity" } },
  { id: SubstanceBehaviorEnum.SPIRITUAL, labels: { 0: "Autotranscendencia / Espiritual", 1: "Spiritual / Self-Transcendence" } },
  { id: SubstanceBehaviorEnum.ANALGESIA, labels: { 0: "Alivio de dolor / Automedicación", 1: "Pain Relief / Self-Medication" } },
  { id: SubstanceBehaviorEnum.ESCAPISM_SEDATION, labels: { 0: "Evasión / Sedación", 1: "Escapism / Sedation" } },
];

// 🎯 Section-Specific Filtered Lists
const getBehaviorsByKeys = (keys) => SUBSTANCES_BEHAVIOR_MAP.filter(item => keys.includes(item.id));

export const ALCOHOL_BEHAVIOR_MAP = getBehaviorsByKeys([
  SubstanceBehaviorEnum.SOCIAL,
  SubstanceBehaviorEnum.ENHANCEMENT,
  SubstanceBehaviorEnum.COPING,
  SubstanceBehaviorEnum.CONFORMITY
]);

export const SMOKING_BEHAVIOR_MAP = getBehaviorsByKeys([
  SubstanceBehaviorEnum.DEPENDENT,
  SubstanceBehaviorEnum.ANXIETY_STRESS,
  SubstanceBehaviorEnum.SOCIAL,
  SubstanceBehaviorEnum.ORAL_FIXATION,
  SubstanceBehaviorEnum.STIMULATION,
  SubstanceBehaviorEnum.HABIT
]);

export const OTHER_SUBSTANCE_BEHAVIOR_MAP = getBehaviorsByKeys([
  SubstanceBehaviorEnum.RECREATIONAL,
  SubstanceBehaviorEnum.ENHANCEMENT,
  SubstanceBehaviorEnum.CURIOSITY,
  SubstanceBehaviorEnum.SPIRITUAL,
  SubstanceBehaviorEnum.ANALGESIA,
  SubstanceBehaviorEnum.ESCAPISM_SEDATION
]);